/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyInfo
 */
export interface CompanyInfo {
    /**
     * 
     * @type {number}
     * @memberof CompanyInfo
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInfo
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyInfo
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    phone?: string | null;
}

export function CompanyInfoFromJSON(json: any): CompanyInfo {
    return CompanyInfoFromJSONTyped(json, false);
}

export function CompanyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'description': json['description'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function CompanyInfoToJSON(value?: CompanyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'url': value.url,
        'description': value.description,
        'address': value.address,
        'phone': value.phone,
    };
}


